export default "__VITE_ASSET__7a75b2e4__"